/**
 * FeatureRows.tsx — én rad per modul (tekst + «Dette finner du»-panel)
 *
 * Radene bruker samme mønster som funksjonsseksjonene på ibm.com/products.
 * Annenhver rad speiles på lg+. Panelet viser kun innhold som finnes i
 * modulen (ingen mock-skjermbilder).
 */

import { Checkmark } from '@carbon/icons-react';
import type { LandingFeature } from '@/types/landing';
import styles from './landing-sections.module.css';

export default function FeatureRows({ features }: { features: LandingFeature[] }) {
  return (
    <div>
      {features.map((feature, index) => (
        <section
          key={feature.id}
          id={`feature-${feature.id}`}
          className={styles.section}
          aria-labelledby={`feature-${feature.id}-heading`}
        >
          <div className={`${styles.container} ${styles.row} ${index % 2 ? styles.rowReverse : ''}`}>
            <div className={styles.rowText}>
              <p className={styles.eyebrow}>
                {feature.eyebrow}
                {feature.status && <span className={styles.tag}>{feature.status}</span>}
              </p>
              <h2 id={`feature-${feature.id}-heading`} className={styles.h2}>
                {feature.heading}
              </h2>
              <p className={styles.lead}>{feature.body}</p>
            </div>

            <div className={styles.panel}>
              <h3 className={styles.panelTitle}>{feature.includesLabel}</h3>
              <ul className={styles.panelList} role="list">
                {feature.includes.map((entry) => (
                  <li key={entry} className={styles.panelItem}>
                    <Checkmark size={20} aria-hidden />
                    <span>{entry}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
